<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Change Jobsite</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Photo">close</i>
  </div>
  <div class="ttmodal__body">
    <div>Which jobsite would you like to move this implement to? </div>
    <mat-form-field class="input">
      <mat-select placeholder="Customer" [(ngModel)]="selectedCustomer" (selectionChange)="loadJobsitesForCustomer()" ngDefaultControl required>
        <mat-option [value]="customer.Id" *ngFor="let customer of customerList">
          {{customer.Name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="input">
      <mat-select placeholder="Job Site" [(ngModel)]="selectedJobsite" ngDefaultControl required>
        <mat-option [value]="jobsite.Id" *ngFor="let jobsite of jobsiteList">
          {{jobsite.Name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="ttmodal__footer">
    <button mat-raised-button (click)="onNoClick()">Cancel</button>
    <button mat-raised-button color="warn" [class.loading]="saving" (click)="updateJobsiteClicked()"><span class="material-icons button__icon">check</span><span class="button__text">Update Jobsite</span></button>
  </div>
</div>
